import { SyntheticEvent } from 'react';

export const combine = <TEvent extends SyntheticEvent>(...handlers: ReadonlyArray<(e: TEvent) => void>) => {
    return (e: TEvent) => handlers.forEach((handler) => handler(e));
};

export const stopPropagation = (e: React.SyntheticEvent) => e.stopPropagation();

export const onKey = <T extends HTMLInputElement>(
    key: string | number,
    handle: (e: React.KeyboardEvent<T>) => void
): React.KeyboardEventHandler<T> => {
    return (e) => {
        const isKey = typeof key === 'string' ? e.key === key : e.keyCode === key;
        if (isKey) {
            handle(e);
        }
    };
};
